/**
 * PWAUpdatePrompt is now a no-op.
 *
 * The root caching service worker has been removed, so there is no
 * "new version" lifecycle to listen for.  This stub remains so
 * existing imports in App.tsx don't break.
 */
export function PWAUpdatePrompt() {
  return null;
}
